import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { WebSocketService, WebSocketMessage } from './websocket.service';

@Component({
  selector: 'app-drawing-stream-popover',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './drawing-stream-popover.component.html',
  styleUrls: ['./drawing-stream-popover.component.scss']
})
export class DrawingStreamPopoverComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Output() closePopover = new EventEmitter<void>();
  public messages: WebSocketMessage[] = [];
  private wsSub?: Subscription;

  constructor(private websocketService: WebSocketService) {}

  close(): void {
    this.closePopover.emit();
  }

  ngOnInit(): void {
    this.wsSub = this.websocketService.getInsertModifyUpdates().subscribe((msg) => {
      this.messages.push(msg);
    });
  }

  ngOnDestroy(): void {
    this.wsSub?.unsubscribe();
  }
}
